
export const themeColors = {
    primary: '#800000',       
    primaryLight: '#A52A2A',  
    primaryDark: '#5C0000',   
    textLight: '#FFFFFF',     
    accent: '#D4AF37',        
    bgLight: '#FFF5F5',       
    borderColor: '#DCC0C0',  
    chartColors: ['#800000', '#A52A2A', '#D4AF37', '#5C0000', '#DCC0C0', '#8B0000', '#B22222', '#CD5C5C']
  };
  
  // Convert satisfaction text to numeric value
  export const satisfactionToNumeric = (satisfaction) => {
    switch (satisfaction) {
      case 'Strongly Agree': return 5;
      case 'Agree': return 4;
      case 'Neutral': return 3;
      case 'Disagree': return 2;
      case 'Strongly Disagree': return 1;
      default: return 0;
    }
  };

  export const serviceQualityQuestions = [
    { id: 'sqd0', label: 'SQD0. I am satisfied with the service that I availed.' },
    { id: 'sqd1', label: 'SQD1. I spent a reasonable amount of time for my transaction.' },
    { id: 'sqd2', label: 'SQD2. The office followed the transaction\'s requirements and steps based on the information provided.' },
    { id: 'sqd3', label: 'SQD3. The steps(including payment) I needed to do for my transaction were easy and simple.' },
    { id: 'sqd4', label: 'SQD4. I easily found information about my transaction from the office or its website.' },
    { id: 'sqd5', label: 'SQD5. I paid a reasonable amount of fees for my transaction.' },
    { id: 'sqd6', label: "SQD6. I feel the office was fair to everyone, or 'walang palakasan', during my transaction." },
    { id: 'sqd7', label: 'SQD7. I was treated courteously by the staff, and (if asked for help) the staff was helpful.' },
    { id: 'sqd8', label: 'SQD8. I got what I needed from the government office, or (if denied) denial of request was sufficiently explained to me.' },
    { id: 'sqd9', label: 'SQD9. I completed the transaction within the expected time frame.' },
    { id: 'sqd10', label: 'SQD10. When I encountered any issues, they were resolved to my satisfaction.' }
  ];

 
export const calculateAverageSQD = (surveyResponses) => {
  // Validate input
  if (!surveyResponses || typeof surveyResponses !== 'object') {
    return { 
      average: 0, 
      error: 'Invalid survey responses' 
    };
  }
  
  let totalScore = 0;
  let validResponses = 0;
  const scores = {};
  
  // Calculate scores for each SQD
  serviceQualityQuestions.forEach(question => {
    const satisfaction = surveyResponses[question.id];
    if (satisfaction) {
      const score = satisfactionToNumeric(satisfaction);
      if (score > 0) {  
        scores[question.id] = score;
        totalScore += score;
        validResponses++;
      }
    }
  });
  
  // Avoid division by zero
  const average = validResponses > 0 ? (totalScore / validResponses).toFixed(2) : 0;
  
  // Return detailed results
  return {
    average: parseFloat(average),
    totalScore,
    validResponses,
    individualScores: scores,
    responseRate: validResponses > 0 ? 
      ((validResponses / serviceQualityQuestions.length) * 100).toFixed(2) + '%' : '0%'
  };
};

export const calculateOverallSQDAverage = (allSurveyResponses) => {
  if (!Array.isArray(allSurveyResponses) || allSurveyResponses.length === 0) {
    return {
      overallAverage: 0,
      error: 'No valid survey responses'
    };
  }
  
  let totalSum = 0;
  let totalValidSurveys = 0;
  const individualAverages = [];
  
  allSurveyResponses.forEach(response => {
    const result = calculateAverageSQD(response);
    if (result.average > 0) {
      totalSum += result.average;
      totalValidSurveys++;
      individualAverages.push(result);
    }
  });
  
  const overallAverage = totalValidSurveys > 0 ? (totalSum / totalValidSurveys).toFixed(2) : 0;
  
  return {
    overallAverage: parseFloat(overallAverage),
    totalValidSurveys,
    totalSurveys: allSurveyResponses.length,
    individualResults: individualAverages
  };
};


  export const getSatisfactionColor = (rating) => {
    if (rating === undefined || rating === null) return '#CCCCCC'; // Gray for no data
  
    // Convert to number if it's a string
    if (typeof rating === 'string') {
      rating = parseFloat(rating);
    }
  
    // Handle exact values and ranges for smoother gradient
    if (rating >= 4.75) return '#1B5E20'; 
    if (rating >= 4.5) return '#2E7D32';  
    if (rating >= 4.0) return '#388E3C';  
    if (rating >= 3.75) return '#43A047'; 
    if (rating >= 3.5) return '#4CAF50';  
    if (rating >= 3.25) return '#66BB6A'; 
    if (rating >= 3.0) return '#FFC107';  
    if (rating >= 2.5) return '#FF9800';  
    if (rating >= 2.0) return '#F57C00';  
    if (rating >= 1.5) return '#F44336';  
    if (rating >= 1.0) return '#D32F2F';  
    
    return '#B71C1C'; 
  };

  export const getSatisfactionLabel = (rating) => {
    if (rating === undefined || rating === null) return 'No Data';
  
    // Convert to number if it's a string
    if (typeof rating === 'string') {
      rating = parseFloat(rating);
    }
  
    if (rating >= 4.5) return 'Very Satisfied';
    if (rating >= 3.5) return 'Satisfied';
    if (rating >= 2.5) return 'Neither Unsatisfied nor Satisfied';
    if (rating >= 1.5) return 'Unsatisfied';
    if (rating >= 1.0) return 'Very Unsatisfied';
    
    return 'Unacceptable';
  };

  export const getSatisfactionEmoji = (rating) => {
    if (rating === undefined || rating === null) return '❓';
  
    // Convert to number if it's a string
    if (typeof rating === 'string') {
      rating = parseFloat(rating);
    }
  
    if (rating >= 4.5) return '😊'; // Very Satisfied
    if (rating >= 3.5) return '🙂'; // Satisfied
    if (rating >= 2.5) return '😕'; // Neither Unsatisfied nor Satisfied
    if (rating >= 1.5) return '🙁'; // Unsatisfied
    if (rating >= 1.0) return '😠'; // Very Unsatisfied
    
    return '😡'; // Unacceptable
  };

export const officeOptions = [
  { value: 'all', label: 'All Offices' },
  { value: 'records_section', label: 'Records Section' },
  { value: 'legal_unit', label: 'Legal Unit' },
  { value: 'cash_section', label: 'Cash Section' },
  { value: 'procurement_unit', label: 'Procurement Unit' },
  { value: 'personnel_section', label: 'Personnel Section' }
];

export const sqdDimensions = {
  sqd0: 'Overall Satisfaction',
  sqd1: 'Transaction Time',
  sqd2: 'Compliance with Requirements',
  sqd3: 'Process Simplicity',
  sqd4: 'Information Accessibility',
  sqd5: 'Fees Reasonability',
  sqd6: 'Fairness',
  sqd7: 'Staff Courtesy',
  sqd8: 'Service Delivery',
  sqd9: 'Timeliness',
  sqd10: 'Issue Resolution'
};

export const clientTypeOptions = [
  { value: 'government', label: 'Government' },
  { value: 'private', label: 'Private' },
  { value: 'student', label: 'Student' },
  { value: 'business', label: 'Business Owner' },
  { value: 'other', label: 'Other' }
];


export const satisfactionLabels = {
  'Strongly Agree': { text: 'Strongly Agree', emoji: '😊', value: 5 },
  'Agree': { text: 'Agree', emoji: '🙂', value: 4 },
  'Neither Agree nor Disagree': { text: 'Neutral', emoji: '😐', value: 3 },
  'Disagree': { text: 'Disagree', emoji: '🙁', value: 2 },
  'Strongly Disagree': { text: 'Strongly Disagree', emoji: '😠', value: 1 },
  'N/A': { text: 'Not Applicable', emoji: '❓', value: null }
};
